/**
 * Zod schemas for /api/search/guides endpoint
 * Full-text search over the help-guide articles in the ElasticSearch guides index
 */

import { z } from 'zod';

// =============================================================================
// REQUEST SCHEMAS
// =============================================================================

export const GuideSearchRequestSchema = z.object({
  q: z.string().optional().default(''),
  limit: z.string().optional().default('8'),
});

export type GuideSearchRequest = z.infer<typeof GuideSearchRequestSchema>;

// =============================================================================
// RESPONSE SCHEMAS
// =============================================================================

export const GuideSearchResultSchema = z.object({
  slug: z.string(),
  title: z.string(),
  description: z.string(),
  category: z.enum(['seller', 'buyer']),
  thumbnail: z.string(),
  url: z.string(),
  /** Body excerpt with the matched terms wrapped in <mark>; absent on title-only matches. */
  snippet: z.string().optional(),
});

export type GuideSearchResult = z.infer<typeof GuideSearchResultSchema>;

export const GuideSearchSuccessResponseSchema = z.object({
  success: z.literal(true),
  query: z.string(),
  results: z.array(GuideSearchResultSchema),
  /** True when ElasticSearch was unavailable and results came from the local corpus. */
  fallback: z.boolean(),
});

export type GuideSearchSuccessResponse = z.infer<typeof GuideSearchSuccessResponseSchema>;

export const GuideSearchErrorResponseSchema = z.object({
  success: z.literal(false),
  error: z.string(),
});

export type GuideSearchErrorResponse = z.infer<typeof GuideSearchErrorResponseSchema>;

export const GuideSearchResponseSchema = z.union([
  GuideSearchSuccessResponseSchema,
  GuideSearchErrorResponseSchema,
]);

export type GuideSearchResponse = z.infer<typeof GuideSearchResponseSchema>;
